define([
	"jquery",
	"underscore",
	"marionette",
	"google_analytics",
	"forms/deposit/deposit_payda_form",
	"behaviors/form_errors_behavior",
	"backbone.syphon"
], function($, _, Marionette, GoogleAnalytics, PaydaForm, FormErrorsBehavior) {

	return Marionette.View.extend({
		el: '#content_layout',
		behaviors: {
			formErrors: {
				behaviorClass: FormErrorsBehavior
			},
		},

		ui: {
			'amount' : '#amount',

			'deposit':'#deposit_btn',
			'hold_on_overlay': '#holdon-overlay',
			'paydaRules' : '#payda_rules',

		},

		events: {
			'keyup @ui.amount': 'requestKrwToUsd',
			'click @ui.deposit': 'deposit',
		},

		initialize: function(){
			$(this.ui.paydaRules).modal('show');

			GoogleAnalytics.sendGaPageviewEvent(GoogleAnalytics.googleAnalyticsUrls.payda_open_amount)
		},

		deposit: function(e) {
			e.preventDefault();

			this.triggerMethod('hide:errors');

			var formData = Backbone.Syphon.serialize(this.$('#form_submit')[0]);
			var form = new PaydaForm();
			form.set( formData);

			var errors = form.validate();

			var that = this;

			if(_.size(errors) < 1){
				$(that.ui.hold_on_overlay).show();

				form.validateWithServer({
					type: 'POST',
					success: function(model, res){
						that.$('#form_submit').submit();

						GoogleAnalytics.sendGaPageviewEvent(GoogleAnalytics.googleAnalyticsUrls.payda_pageout)
					},

					error: function(model, error){
						$(that.ui.hold_on_overlay).hide();
						that.triggerMethod('show:errors', error.responseJSON);
					}
				});
			}else{
				this.triggerMethod('show:errors', errors);
			}
		},

		requestKrwToUsd: function(e) {
			if(this.timer) {
				clearTimeout(this.timer)
			}
			this.timer = setTimeout(function () {
				const krw = $('#amount').val();
				if (isNaN(krw) || krw === '' || !krw) {
					$('#expected_amount').val('-');
					return;
				}

				$.ajax({
					url: `/rest_deposit/payda_deposit_rate?krw=${krw}`,
					type: 'GET',
					success: function (data) {
						if (!data.deposit_rated_amount)
						{
							if(krw < 50000)
							{
								$('#expected_amount').text('-');
								$('#deposit_btn').attr('disabled', true);
								$('#error_amount').text(data.message_min_amount);
							}
							else
							{
								$('#expected_amount').text('-');
								$('#deposit_btn').attr('disabled', true);
								$('#error_amount').text('');
							}
							return;
						}

						if(!data.deposit_info_daily.is_depositable)
						{
							$('#expected_amount').text(data.deposit_rated_amount);
							$('#deposit_btn').attr('disabled', true);
							if (data.deposit_info_daily.is_simple_member)
							{
								$('#error_amount').text(data.message_simple_limit);
							}
							else
							{
								$('#error_amount').text(data.message_daily_limit);
							}

							return;
						}

						if(krw >= 50000 && krw <= 10000000)
						{
							$('#expected_amount').text('$' + data.deposit_rated_amount);
							if (data.deposit_info_daily.is_simple_member && !data.deposit_info_daily.is_depositable) {
								$('#deposit_btn').attr('disabled', true);
								$('#error_amount').text(data.message_simple_limit);
							} else {
								$('#deposit_btn').attr('disabled', false);
								$('#error_amount').text('');
							}
							return;
						}
						else if(krw < 50000)
						{
							$('#expected_amount').text('-');
							$('#deposit_btn').attr('disabled', true);
							$('#error_amount').text(data.message_min_amount);
							return;
						}
						else
						{
							$('#expected_amount').text('-');
							$('#deposit_btn').attr('disabled', true);
							$('#error_amount').text(data.message_max_amount);
							return;
						}
					},
				});
			}, 300);
		},
	});
});
